// src/components/Hero/Hero.jsx
import React from "react";
import Button from "../button/Button";

const Hero = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  variant = "secondary",
  align = "left",
  imageHero,
}) => {
  return (
    <section className="relative isolate min-h-[520px] overflow-hidden bg-[#3f6fe5] py-14 [--hero-grid:115px] sm:min-h-0 sm:py-16 lg:py-20">
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed)",
          backgroundRepeat: "no-repeat",
          backgroundSize:
            "var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid)",
          backgroundPosition:
            "calc(var(--hero-grid) * 3) 0, calc(var(--hero-grid) * 12) 0, calc(var(--hero-grid) * 13.6) var(--hero-grid), calc(var(--hero-grid) * 4) calc(var(--hero-grid) * 3), calc(var(--hero-grid) * 8) calc(var(--hero-grid) * 3)",
        }}
      ></div>
      <div
        className="absolute inset-0 opacity-70"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.28) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,0.28) 2px, transparent 2px)",
          backgroundSize: "var(--hero-grid) var(--hero-grid)",
        }}
      ></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 lg:gap-16">
          <div
            className={`flex flex-col ${
              align === "left"
                ? "items-center md:items-start"
                : "items-center text-center"
            }`}
          >
            <div
              className={`w-full ${
                align === "left"
                  ? "text-center md:text-left"
                  : "text-center mx-auto"
              }`}
            >
              <div
                className={`mb-3 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/12 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white ${
                  align === "left" ? "" : "mx-auto"
                }`}
              >
                Solusi finansial dalam satu genggaman
              </div>
              <h1 className="mb-3 max-w-2xl text-2xl font-bold leading-[1.15] tracking-tight text-white drop-shadow-md sm:text-[28px] lg:text-4xl xl:text-[44px]">
                {title}
              </h1>
              {subtitle && (
                <p className="mx-auto mb-5 max-w-lg text-sm leading-relaxed text-white/90 sm:mb-7 sm:text-[15px] md:mx-0">
                  {subtitle}
                </p>
              )}
              {buttonText && buttonLink && (
                <div
                  className={`flex ${
                    align === "left"
                      ? "justify-center md:justify-start"
                      : "justify-center"
                  }`}
                >
                  <a
                    href={buttonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      variant={variant}
                      className="px-4 py-2 text-sm sm:px-4 sm:py-2"
                    >
                      {buttonText}
                    </Button>
                  </a>
                </div>
              )}
            </div>
          </div>
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-x-8 bottom-4 h-16 rounded-[50%] bg-[#2458d3]/25 blur-xl"></div>
            <img
              src={imageHero}
              alt=""
              className="relative mx-auto h-auto w-full max-w-[170px] object-contain drop-shadow-2xl transition-transform duration-500 hover:-translate-y-2 hover:scale-[1.02] sm:max-w-[210px] lg:max-w-[260px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
